<template>
	<div>
		<section class="text-xs-left">
			<label class="label-title">Completa los datos</label>
			<p class="caption red--text"
			v-if="!$v.user.activeEmployement.required">Seleccionar cargo al usuario</p>
			<div class="employment-grid">
				<employment-component
					v-for="(emp, indexEmp) in listEmploye"
					:key="indexEmp"
					:title="emp.name"
					:icon="emp.urlImage[0]"
					:id="emp.id"
					@selected-employ="loadEmployeesNew"
					:employee-active="user.activeEmployement"
				/>
			</div>
			<label class="employ-info">{{contentX}}</label>
		</section>
		<hr class="section-spacer my-4"/>
		<section class="complete-data text-xs-left mt-3">
				<v-switch
					hide-details
					label="Complete los Datos"
					color="success"
					class="input-switch"
					v-model="completeDataActive">
					</v-switch>
			<v-layout row wrap v-if="completeDataActive">
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Nombre"
						placeholder="Nombre"
						v-model="user.name"
					/>
					<span 
					class="caption red--text"
					v-if="!$v.user.name.required"
					>
						Campo Requerido
					</span>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Apellido"
						placeholder="Apellido"
						v-model="user.lastname"
					/>
					<span 
					class="caption red--text"
					v-if="!$v.user.lastname.required"
					>
						Campo Requerido
					</span>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<select-date
						label
						labelText="Fecha de naciemiento"
						v-model="user.dateBirth"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<select-button
						label
						labelText="Género"
						itemText="name"
						itemValue="id"
						:items="genders"
						v-model="user.gender"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Correo"
						placeholder="Correo"
						type="email"
						v-model="user.email"
					/>
					<span class="text-validate"
					v-if="!validateEmail(user.email)">
						Ingrese Email valido
					</span>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Teléfono"
						placeholder="Teléfono"
						type="number"
						v-model="user.phone"
					/>
					<span
					v-if="!$v.user.phone.minLength"
					class="caption red--text">mínimo 6 digitos</span>
					<span
					class="caption red--text"
					v-if="!$v.user.phone.maxLength">maximo 11 digitos</span>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Codigo ACL"
						placeholder="Codigo ACL"
						type="text"
						v-model="user.aclCode"
					/>
					<span class="text-validate"
					v-if="!$v.user.aclCode.required">
						Ingrese Codigo 
					</span>
				</v-flex>
				<v-flex xs3 text-xs-left mb-2 mr-4 mt-3>
					<v-select
					:items="typeDocument"
					autocomplete
					class="filter-select filter-select-autocomplete filter-select-indicator"
					item-text="code"
					item-value="id"
					v-model="user.documentType"
					hide-details
					single-line
					bottom></v-select>
					<v-text-field
					type="number"
					class="input-border-inset input-form-select"
					v-model="user.numDocument"
					></v-text-field>
				</v-flex>
			</v-layout>
		</section>
		<section class="text-xs-left mb-3">
			<label class="label-title">Seleccione las Sucursales</label>
			<div class="subsidiaries-grid">
				<v-checkbox
				label="Seleccionar Todos"
				hide-details
				class="input-checkbox input-booking"
				v-model="allSubsidiary"
				@change="selectAll('subsidiaries', subsidiaries, allSubsidiary)"
				></v-checkbox>
				<v-checkbox
					class="input-checkbox input-booking"
					hide-details
					v-for="(subsidiary, indexSub) in subsidiaries"
					:key="indexSub"
					:value="subsidiary.isSelected"
					:label="subsidiary.sucursal_name"
					v-model="user.subsidiariesId"
				></v-checkbox>
			</div>
		</section>
		<v-layout row mt-3>
			<v-flex xs2 d-flex justify-start>
				<v-btn
					class="btn-action btn-save white--text"
					@click="saveCustomer"
					:disabled="!disabledBtn"
				>
					Guardar
				</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>
import { required, maxLength, minLength } from 'vuelidate/lib/validators';
import mixin from '@/shared/mixins';
import employmentComponent from '@/clerkinn/shared/EmploymentComponent';
import inputText from '@/clerkinn/shared/input-text';
import selectDate from '@/clerkinn/shared/select-date';
import selectButton from '@/clerkinn/shared/select-button';
import lib from '@/shared/lib';

const { map, setNewProperty, compose } = lib;
const baseUrl = process.env.PMS_URL;

function loadEmployeesNew(employ, id) {
	this.user.activeEmployement = id;
}

function validations() {
	const subsidiary = {
		isSelected: {
			required,
		},
	};
	const user = {
		activeEmployement: {
			required,
		},
		name: {
			required,
		},
		lastname: {
			required,
		},
		aclCode: {
			required,
		},
		documentType: {
			required,
		},
		numDocument: {
			required,
		},
		phone: {
			minLength: minLength(6),
			maxLength: maxLength(11),
		},
	};
	return {
		user,
		subsidiary,
	};
}

async function loadResources() {
	const request = [
		this.$http.get(`${process.env.PMS_URL}/documents-type`),
	];
	const [documentType] = await Promise.all(request);
	this.typeDocument = documentType.data.data;
}

function validateEmail(email) {
	return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(email);
}

function disabledBtn() {
	return (this.user.name !== '' && this.user.lastname !== '' && this.user.aclCode !== '' && this.user.phone !== '') && this.validateEmail(this.user.email);
}

function numDocumentLength() {
	if (this.user.documentType === 1) {
		return 8;
	} else if (this.user.documentType === 4) {
		return 11;
	}
	return 0;
}

function created() {
	this.loadHotels();
	this.loadEmployees();
	this.loadResources();
	this.employeeId = this.$route.query.employeeId;
	if (this.employeeId) {
		this.putEmployee(this.employeeId);
	}
}

function mounted() {
	this.putEmployee();
}

function selectAll(name, collection, value) {
	this[name] = map(setNewProperty('isSelected', value), collection);
}

async function loadEmployees() {
	const { data: response } = await this.$http.get(`${baseUrl}/charges`);
	this.listEmploye = response.data;
}

async function loadHotels() {
	const { data: response } = await this.$http.get(`${baseUrl}/hotel`);
	this.subsidiaries = response.data;
	const subsidiary = this.subsidiaries;
	const subUser = this.subsidiaries.map((r) => {
		const subsidiaryHotel = {};
		const prue = subsidiary.find(sub => sub.id === r.id);
		if (prue) {
			subsidiaryHotel.isSelected = prue.isSelected;
		} else {
			subsidiaryHotel.isSelected = false;
		}
		subsidiaryHotel.id = r.id;
		subsidiaryHotel.sucursal_name = r.name;
		return subsidiaryHotel;
	});
	this.subsidiaries = subUser;
}

async function putEmployee() {
	try {
		const { data: response } = await this.$http.get(`${baseUrl}/employees/${this.employeeId}`);
		this.user = response.data;
		this.user.activeEmployement = response.data.charges.data.id;
	} catch (err) {
		if (err.message === 'EMPLOYEE_NOT_FOUND') {
			this.showNotification('Completar datos requeridos', 'error');
		}
	}
}

function showEmployeeData(info) {
	const { data: user } = info;
	return compose(
		setNewProperty('name', user.name),
		setNewProperty('lastname', user.lastname),
		setNewProperty('email', user.email),
		setNewProperty('phone', user.phone),
		setNewProperty('gender', user.gender),
		setNewProperty('idSubsidiary', user.idSubsidiary),
		setNewProperty('password', user.aclCode),
		setNewProperty('dateBirth', user.dateBirth),
		setNewProperty('subsidiariesId', user.subsidiariesId),
		setNewProperty('documentType', user.documentType),
		setNewProperty('numDocument', user.numDocument),
	)(this.user);
}

async function saveCustomer() {
	const employeePost = {
		email: this.user.email,
		flagAdmin: this.user.flagAdmin,
		idCharge: this.user.activeEmployement,
		idSubsidiary: this.user.idSubsidiary,
		name: this.user.name,
		numDocument: this.user.numDocument,
		typeDocument: this.user.typeDocument,
		gender: this.user.gender,
		aclCode: this.user.aclCode,
		dateBirth: this.user.dateBirth,
	};
	try {
		await this.$http.post(`${baseUrl}/employees`, employeePost);
		this.showNotification('Usuario Creado', 'success');
		this.$router.push({ name: 'user-list' });
	} catch (error) {
		this.showNotification('Completar Datos Requeridos', 'error');
	}
}

function buildBody(user) {
	return compose(
		setNewProperty('name', user.name),
		setNewProperty('lastname', user.lastname),
		setNewProperty('email', user.email),
		setNewProperty('phone', user.phone),
		setNewProperty('gender', user.gender),
		setNewProperty('idSubsidiary', user.idSubsidiary),
		setNewProperty('password', user.aclCode),
		setNewProperty('dateBirth', user.dateBirth),
		setNewProperty('subsidiariesId', user.subsidiariesId),
	({}));
}

function data() {
	return {
		employeeId: 0,
		typeDocument: [],
		completeDataActive: true,
		listEmploye: [],
		isSelected: '',
		allSubsidiary: false,
		subsidiaries: [],
		contentX: 'But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful.',
		genders: [
			{ id: 1, name: 'Hombre' },
			{ id: 2, name: 'Mujer' },
		],
		user: {
			charge: {
				code: '',
				description: '',
				flagActive: 0,
				id: 0,
				name: '',
			},
			activeEmployement: '',
			flagAdmin: 0,
			idCharge: 0,
			idSubsidiary: 0,
			checked: '',
			dateBirth: '',
			confirmPassword: '',
			email: '',
			gender: '',
			lastname: '',
			name: '',
			newPassword: '',
			aclCode: '',
			phone: '',
			numDocument: '',
			documentType: 0,
			subsidiariesId: 0,
		},
	};
}

export default {
	mixins: mixin,
	mounted,
	name: 'user-new',
	validations,
	components: {
		employmentComponent,
		inputText,
		selectButton,
		selectDate,
	},
	computed: {
		disabledBtn,
		numDocumentLength,
	},
	created,
	data,
	methods: {
		buildBody,
		showEmployeeData,
		putEmployee,
		loadEmployeesNew,
		loadResources,
		validateEmail,
		loadEmployees,
		selectAll,
		loadHotels,
		saveCustomer,
	},
};
</script>

<style lang="scss" scoped>
.employment-grid {
	align-content: center;
	display: grid;
	grid-gap: 11px;
	grid-template-columns: repeat(auto-fit, minmax(100px, 100px));
	margin: 10px 0 20px;
}

.employ-info {
	color: map-get($colors, border-radio);
	font-size: map-get($sizes, twelve);
}

.subsidiaries-grid {
	align-content: center;
	display: grid;
	grid-gap: 11px;
	grid-template-columns: repeat(auto-fit, minmax(169px, 170px));
}

.text-validate {
	color: red;
	font-size: 12px;
}
</style>




// WEBPACK FOOTER //
// New.vue?1a703d80